document.addEventListener("DOMContentLoaded", () => {
  const menuItems = document
    .querySelector(".header__inline-menu")
    .querySelectorAll("details");

  menuItems.forEach((menuItem) => {
    const trigger = menuItem.querySelector("summary");
    const dropdown = menuItem.querySelector(".mega-menu__content");

    if (!trigger || !dropdown) return;

    let closeTimeout;

    // Open menu
    const openMenu = () => {
      if (window.innerWidth >= 990) {
        clearTimeout(closeTimeout);
        menuItem.setAttribute("open", "");
      }
    };

    // Close menu with slight delay (to allow diagonal movement)
    const closeMenu = () => {
      if (window.innerWidth >= 990) {
        closeTimeout = setTimeout(() => {
          menuItem.removeAttribute("open");
        }, 150); // 150ms delay feels natural
      }
    };

    // Hover on title or mega menu keeps it open
    trigger.addEventListener("mouseenter", openMenu);
    dropdown.addEventListener("mouseenter", openMenu);

    // Leaving title or menu schedules closing
    trigger.addEventListener("mouseleave", closeMenu);
    dropdown.addEventListener("mouseleave", closeMenu);
  });
});
